import React from 'react';

import { collapseSiblingRe, matchMarkGroupsRe } from '@neptune/shared/common-util';

type TextWithMatchingProps = {
  text: string;
};

export const TextWithMatching = ({ text }: TextWithMatchingProps) => {
  const pairs = [...text.replace(collapseSiblingRe, '').matchAll(matchMarkGroupsRe)]
    .filter(([, normal, matching]) => normal || matching)
    .map(([, normal, matching]) => ({ normal, matching }));

  return (
    <>
      {pairs.map(({ normal, matching }, index) => (
        <span key={index}>
          {normal}
          {matching && <mark>{matching}</mark>}
        </span>
      ))}
    </>
  );
};
